@if (isSingleNavLink(route)) {
  <app-a
    class="main-nav-tree__single-link"
    [tid]="testId"
    [routeTo]="route.routerLink!"
    [bold]="false"
    [class.active]="activeTitle === route.title"
  >
    @if (route.icon) {
      <app-icon class="main-nav-tree__header-icon" [size]="'small'" [color]="'primary-action'">{{
        route.icon
      }}</app-icon>
    }
    <app-body-md [ink]="'ink-white'">{{ route.title }}</app-body-md>
  </app-a>
} @else if (isExpandableNavSection(route)) {
  <button
    type="button"
    class="main-nav-tree__header"
    [class.main-nav-tree__header--nested]="nested"
    [tid]="testId"
    [class.expanded]="isExpanded"
    [class.active]="nested ? activeTitle === route.title : isNavSectionActive(route, activeTitle)"
    [attr.aria-expanded]="isExpanded"
    (click)="toggle.emit(route)"
  >
    @if (route.icon) {
      <app-icon class="main-nav-tree__header-icon" [size]="'small'" [color]="'primary-action'">{{
        route.icon
      }}</app-icon>
    }
    <app-body-md [ink]="'ink-white'">{{ route.title }}</app-body-md>
    <app-icon class="main-nav-tree__chevron" [size]="'small'" [color]="'primary-action'">expand_more</app-icon>
  </button>
  <div
    class="main-nav-tree__panel"
    [class.main-nav-tree__panel--nested]="nested"
    [class.main-nav-tree__panel--expanded]="isExpanded"
    [attr.aria-hidden]="isExpanded ? null : 'true'"
    [attr.inert]="isExpanded ? null : ''"
  >
    <div class="main-nav-tree__panel-inner">
      @if (route.children?.length) {
        @for (child of route.children; track child.title) {
          <div class="main-nav-tree__nested-section">
            <app-nav-tree-section
              [route]="child"
              [nested]="true"
              [activeTitle]="activeTitle"
              [expandedTitles]="expandedTitles"
              (toggle)="toggle.emit($event)"
            />
          </div>
        }
      } @else {
        <app-sub-nav [groups]="route.drawer?.groups ?? []" />
      }
    </div>
  </div>
}
